export default function BasketFactory(
    $rootScope,
    $q,
    $timeout,
    siteService,
    houseService,
    BasketJar,
    BasketStorage,
    localStorageService,
    basketConditionFactory,
    SearchPrioritizeFactory,
    moment,
    Log
) {
    var fn = this;

    fn.TESTforceBookingToBeOutdated = (period) => {
        const start = "2020-10-14T14:30:00";
        const end = "2020-10-14T15:30:00";

        period.FromDate = start;
        period.ToDate = end;
        period.Date = "2020-10-14";

        period.BookingStart = start;
        period.BookingEnd = end;

        console.warn("TEST - Forcing 1 booking to be outdated");

        // //  is moment later than overdueMoment

        return period;
    };

    fn.isPeriodOverdue = (end) => {
        return moment() > moment(end);
    };

    fn.addPeriod = (lane, period) => {
        Log.obj("Basket: period added : ", period, "highlight");
        Log.obj("Basket: added from lane : ", lane);
        // TEST 1 :
        // period = fn.TESTforceBookingToBeOutdated(period);

        if (fn.isPeriodOverdue(period.BookingEnd)) {
            return $q.reject("period-is-overdue");
        }

        const dublicates = BasketJar.currentBookings.filter((booking) => {
            return booking.Periods[0].UniqueKey == period.UniqueKey;
        });

        if (dublicates.length) {
            return $q.reject("period-allready-in-basket");
        }

        // business logic check - popup with user action ( continue or not! );

        return conditionalBookingResetCheck().then((userAnswer) => {
            // PUT PERIOD IN THE BASKET
            if (userAnswer == true) {
                // defaults to true

                period.selected = true;

                // period.BookingStart = moment().add("1", "minutes").format();

                // Simple booking object
                var simpleBooking = {
                    ID: BasketJar.currentBookings.length, // first booking will have ID 0
                    CategoryID:
                        houseService.searchFilter.houseCategory.CategoryID,
                    houseCategory: houseService.searchFilter.houseCategory,
                    houseType: houseService.searchFilter.houseType,
                    LaneID: lane.LaneID,
                    LaneName: lane.LaneName,
                    Price: period.Price,
                    BookingStart: period.BookingStart,
                    BookingEnd: period.BookingEnd,
                    FromDate: period.BookingStart,
                    ToDate: period.BookingEnd,
                    Date: moment(period.BookingStart).format("YYYY-MM-DD"),
                    Periods: [],
                    _periodSearchDate: houseService.searchFilter.startDate,
                    Priority: lane.Priority,
                };

                // Add to cart (selected bookings);
                simpleBooking.Periods.push(period);
                BasketJar.currentBookings.push(simpleBooking);

                // Used by conditionalBookingResetCheck and Basket header
                setCurrentBookingActivityAndLocation(
                    houseService.searchFilter.houseCategory,
                    houseService.searchFilter.houseType
                );

                // Save booking in localstorage
                BasketStorage.setBookingsStorage(BasketJar.currentBookings);

                $rootScope.$broadcast("booking-added-to-basket");

                detectRepeatablePattern();

                return $q.resolve();
            } else {
                period.selected = false;
                // return $q.resolve();
            }
        });
    };

    fn.removePeriod = (period) => {
        period.selected = false;

        Log.obj("PERIOD to remove : ", period);

        /**
         * B.L. : if removal of prioritized period from basket - Remove lowest prios first.
         */
        SearchPrioritizeFactory.findPrioritizedLanes({
            ParentLanes: [{ Lanes: angular.copy(BasketJar.currentBookings) }], // recreate search structure
        }).then((res) => {
            period = lookForLowerPriorities(period, res);

            /**
             *
             */
            BasketJar.currentBookings.forEach((booking, index) => {
                Log.string(
                    "BASKET",
                    period.UniqueKey +
                        " == " +
                        booking.Periods[0].UniqueKey +
                        " Match " +
                        (period.UniqueKey == booking.Periods[0].UniqueKey)
                );

                /** Find the one  */
                if (period.UniqueKey == booking.Periods[0].UniqueKey) {
                    // Remove Booking from Basket!

                    BasketJar.currentBookings.splice(index, 1);

                    $rootScope.$broadcast("booking-removed-basket", booking); // search/periods reprocess

                    BasketStorage.setBookingsStorage(BasketJar.currentBookings);
                }
            });

            if (!BasketJar.currentBookings.length) {
                Log.string("resetBasketHouseCategoryAndType");

                resetBasketHouseCategoryAndType();
            }

            detectRepeatablePattern();
        });
    };

    const lookForLowerPriorities = (period, basketTimeslotGroups) => {
        if (!basketTimeslotGroups) {
            return period;
        }

        // find bookings in same timeslot - at the same day
        const timeslotGroupToEvaluate = basketTimeslotGroups.find(
            (basketTimeslot) => {
                if (basketTimeslot.slot.BookingStart === period.BookingStart) {
                    return basketTimeslot;
                }
            }
        );

        if (!timeslotGroupToEvaluate) {
            return period;
        }

        const lowestPrioPeriod =
            timeslotGroupToEvaluate.periods[
                timeslotGroupToEvaluate.periods.length - 1
            ];

        return lowestPrioPeriod;
    };

    /**
     * Business Logic
     * only allow one location (anlæg/stedet) or one activity (aktivitet) in basket
     * @return bool user answer
     */
    const conditionalBookingResetCheck = () => {
        Log.obj(
            "Conditional : searchFilter : ",
            houseService.searchFilter.houseCategory
        );
        Log.obj("Conditional : BasketJar activity: ", BasketJar.activity);

        Log.obj(
            "Conditional : searchFilter : ",
            houseService.searchFilter.houseType
        );
        Log.obj("Conditional : BasketJar location: ", BasketJar.location);

        if (
            (BasketJar.activity &&
                BasketJar.activity.CategoryID !==
                    houseService.searchFilter.houseCategory.CategoryID) ||
            (BasketJar.location &&
                BasketJar.location.ID !==
                    houseService.searchFilter.houseType.ID)
        ) {
            return basketConditionFactory.modal().then(function (answer) {
                if (answer == true) {
                    // reset bookings array
                    BasketJar.currentBookings.splice(
                        0,
                        BasketJar.currentBookings.length
                    ); // reset array!

                    // BasketStorage.deleteBookingId();

                    return true;
                } else {
                    //user do not want empty basket
                    return false;
                }
            });
        } else {
            var deferred = $q.defer();

            deferred.resolve(true);

            return deferred.promise;
        }
        // we need true if booking should come into basket
        // return true;
    };

    fn.CheckPeriodDateIsExpired = (end) => {
        const now = moment();

        const bookingEnd = moment(end);

        Log.string(
            "Basket periods: is ",
            bookingEnd.format("DD.MM.YY - HH:ss") +
                " ? outdated ?" +
                (bookingEnd < now)
        );

        // expired ?
        return bookingEnd < now; // do not allow bookingPeriods which is in the past (bookingEnd time)
    };

    /**
     * Find repeatable pattern
     * broadcast event
     * (triggers UI tooltip)
     */
    const detectRepeatablePattern = () => {
        if (
            localStorageService.get("repeatableBookingPatternTooltip") !==
            "true"
        ) {
            var repeatedBooking = null;

            BasketJar.currentBookings.forEach((bookingOuter, keyOuter) => {
                var n = moment(bookingOuter.BookingStart);

                // console.log('---- ' + key + '----')

                angular.forEach(
                    BasketJar.currentBookings,
                    function (bookingInner, keyInner) {
                        if (keyOuter !== keyInner) {
                            // skip same entry

                            var m = moment(bookingInner.BookingStart).add(
                                7,
                                "days"
                            );

                            /**
                             *  moment.js (compare 2 moment object)
                             * https://momentjs.com/docs/#/query/is-same/
                             **/

                            if (n.isSame(m)) {
                                repeatedBooking = bookingOuter;
                            }
                        }
                    }
                );
            });

            if (repeatedBooking) {
                $timeout(function () {
                    //console.log(siteService);

                    if (siteService.deviceMode == "desktop") {
                        $rootScope.$broadcast("show-tooltip-repeatable", {
                            repeatedBooking: repeatedBooking,
                        });
                    }

                    if (
                        siteService.deviceMode == "mobile" &&
                        !siteService.asideState.open
                    ) {
                        $rootScope.$broadcast("repeatable-pattern-detected", {
                            repeatedBooking: repeatedBooking,
                        });
                    }

                    localStorageService.set(
                        "repeatableBookingPatternTooltip",
                        true
                    );
                });
            }
        }
    };

    const resetBasketHouseCategoryAndType = function () {
        BasketJar.activity = null;
        BasketJar.location = null;

        BasketStorage.setBookingActivity(null);
        BasketStorage.setBookingLocation(null);
    };

    const setCurrentBookingActivityAndLocation = function (
        activity = null,
        location = null
    ) {
        BasketJar.activity = angular.copy(activity);
        BasketJar.location = angular.copy(location);

        BasketStorage.setBookingActivity(activity);
        BasketStorage.setBookingLocation(location);
    };

    return fn;
}
